// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1v_q9","bigColWidth":"Table_bigColWidth__3bPee","biggerColWidth":"Table_biggerColWidth__2Xs0v","row":"Table_row__AhEGB","col":"Table_col__28AJa"};